import store from '@/state/store'

export default async (to, from, next) => {
    //for Server Side Validate.
    if(process.env.VUE_APP_API_VALIDATE_TOKEN == 'serverSide')
    {
        const status = await store.dispatch('auth/validate');
        
        if(status == 200)
        {
            next({ name: '/' })
        }
    }
    //for Client Side Validate.
    else if(store.getters['auth/loggedIn']){
        next({ name: '/' })
    }

    next()
}